jQuery(document).ready(function ($) {
  const $slider = $(".news-slider__wrapper__slider");
  const $nav = $(".news-slider__wrapper__nav");

  if (!$slider.length || typeof $.fn.slick !== 'function') {
    return;
  }

  $slider.slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 1000,
    fade: true,
    cssEase: "linear",
    arrows: false,
    dots: true,
    appendDots: $nav,
    pauseOnHover: false,
    pauseOnFocus: false,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          fade: false,
          cssEase: "ease",
        },
      },
    ],
  });
});

document
  .querySelectorAll(".podcasts__wrapper__podcasts__others__single")
  .forEach((item) => {
    item.addEventListener("click", function () {
      const id = this.dataset.id;
      const title = this.dataset.title;
      const date = this.dataset.date;
      const isMemberOnly = this.dataset.memberOnly === "true";
      const thumbnail = this.dataset.thumbnail;

      const mainVideo = document.getElementById("main-video");

      if (isMemberOnly) {
        mainVideo.innerHTML = `
          <div class="video-thumbnail aspect-ratio-16-9 is-member-only"
               data-id="${id}"
               data-member-only="true">
            <span class="caption-sponsored w-400 dflex aicenter gap-12">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="21" viewBox="0 0 17 9" fill="none">
                <path d="M7.69968 2.58286L5.64601 7.31549L2.45597 0.122433H3.14419H3.20191V0H2.40158H0.91122H0.0776367V0.122433H0.965608L4.48503 8.0592H5.49704L5.73338 7.51307L7.84199 2.61516C7.79367 2.6052 7.74527 2.5954 7.69968 2.58286Z" fill="white" />
                <path d="M13.7023 0V0.122433V0.124654C14.3055 0.147351 14.7868 0.556063 14.7868 1.05847C14.7868 1.12049 14.76 1.2424 14.7294 1.34546L14.7289 1.34622L12.139 7.31549L9.15943 0.596918L9.15999 0.597995C9.02679 0.297251 9.29473 0.120017 9.61733 0.122433H9.63779H9.69495H9.71814H9.76571H10.1797H10.2271V0H9.76567H9.69491H8.89467H7.67157H7.40399H7.2101H6.5708V0.122433H7.2101H7.45837L9.93106 5.69834H7.11476V5.83139H9.99004L10.978 8.0592H11.9906L12.2266 7.51307L15.1067 0.822844L15.1178 0.804947C15.1248 0.784699 15.1326 0.764614 15.1411 0.74502C15.2978 0.382225 15.7169 0.122433 16.2111 0.122433H16.2583V0H13.7023ZM15.1278 0.33915L14.7438 1.32414L14.7429 1.32551C14.8584 1.02927 15.1278 0.33915 15.1278 0.33915Z" fill="white" />
              </svg>
              Samo za članice
            </span>
            <img src="${thumbnail}" alt="${title}">
          </div>
        `;
      } else {
        mainVideo.innerHTML = `
          <iframe 
            src="https://www.youtube-nocookie.com/embed/${id}?autoplay=1"
            allow="autoplay; encrypted-media"
            allowfullscreen>
          </iframe>
        `;
      }

      document.getElementById("main-title").innerText = title;
      document.getElementById("main-date").innerText = date;

      const currentlyPlaying = document.querySelector(
        ".podcasts__wrapper__podcasts__currently-playing"
      );

      currentlyPlaying.classList.remove("is-member-only", "is-public");
      currentlyPlaying.classList.add(isMemberOnly ? "is-member-only" : "is-public");

      document
        .querySelectorAll(".current-video")
        .forEach((el) => el.classList.remove("current-video"));

      this.classList.add("current-video");
    });
  });

jQuery(document).ready(function ($) {
  const $toggle = $(".zd-site-header__main__wrapper__toggle-nav__nav:not(.js-back-btn)");
  const $megamenu = $(".megamenu");
  const $body = $("body");
  const $html = $("html");
  let lockedScrollY = 0;
  let isScrollLocked = false;

  function isMobile() {
    return window.matchMedia("(max-width: 767px)").matches;
  }

  function lockScroll() {
    if (isScrollLocked) {
      return;
    }

    isScrollLocked = true;
    lockedScrollY = window.scrollY || window.pageYOffset || 0;

    $html.css("overflow", "hidden");
    $body.css({
      overflow: "hidden",
      position: "fixed",
      top: -lockedScrollY + "px",
      left: 0,
      right: 0,
      width: "100%",
    });
  }

  function unlockScroll() {
    if (!isScrollLocked) {
      return;
    }

    isScrollLocked = false;

    $html.css("overflow", "");
    $body.css({
      overflow: "",
      position: "",
      top: "",
      left: "",
      right: "",
      width: "",
    });

    window.scrollTo(0, lockedScrollY);
  }

  function openMegamenu() {
    $megamenu.addClass("megamenu-active");
    $toggle.addClass("toggle-active");

    if (isMobile()) {
      lockScroll();
    }
  }

  function closeMegamenu() {
    $megamenu.removeClass("megamenu-active");
    $toggle.removeClass("toggle-active");
    unlockScroll();
  }

  $toggle.on("click", function (e) {
    e.stopPropagation();

    if ($megamenu.hasClass("megamenu-active")) {
      closeMegamenu();
    } else {
      openMegamenu();
    }
  });

  $megamenu.on("click", function (e) {
    e.stopPropagation();
  });

  $(document).on("click", function (e) {
    if (
      !$megamenu.is(e.target) &&
      $megamenu.has(e.target).length === 0 &&
      !$toggle.is(e.target) &&
      $toggle.has(e.target).length === 0
    ) {
      closeMegamenu();
    }
  });

  $(window).on("scroll", function () {
    if ($megamenu.hasClass("megamenu-active") && !isMobile()) {
      closeMegamenu();
    }
  });
});

jQuery(document).ready(function ($) {
  function updateHasValue(el) {
    var $el = $(el);
    var $wrap = $el.closest(".form-field");
    var value = $el.val();

    if (value && value.trim() !== "") {
      $wrap.addClass("has-value");
    } else {
      $wrap.removeClass("has-value");
    }
  }

  $('input[type="text"], input[type="email"], input[type="password"]').each(
    function () {
      updateHasValue(this);
    },
  );

  $('input[type="text"], input[type="email"], input[type="password"]').on(
    "input blur",
    function () {
      updateHasValue(this);
    },
  );

  $("select").each(function () {
    updateHasValue(this);
  });

  $("select").on("change", function () {
    updateHasValue(this);
  });
});

jQuery(document).ready(function ($) {
  function updateHasValue(el) {
    var $el = $(el);
    var $wrap = $el.closest(".form-field");
    var value = $el.val();

    if ($el.attr("type") === "checkbox") {
      if ($el.is(":checked")) {
        $wrap.addClass("has-value");
      } else {
        $wrap.removeClass("has-value");
      }
      return;
    }

    if (value && value.trim() !== "") {
      $wrap.addClass("has-value");
    } else {
      $wrap.removeClass("has-value");
    }
  }

  $("input").each(function () {
    updateHasValue(this);
  });

  $("input").on("input blur change", function () {
    updateHasValue(this);
  });
});

jQuery(document).ready(function ($) {
    $('.password-toggle').on('click', function () {
        const $button = $(this);
        const $input = $button.closest('.password-field').find('input');
        const isPassword = $input.attr('type') === 'password';

        $input.attr('type', isPassword ? 'text' : 'password');
        $button.text(isPassword ? 'Sakrij' : 'Prikaži');
    });
});

jQuery(document).ready(function () {
  const config = window.zdCrmAcfRegionFilter || {};
  const regionChoices = config.regionChoices || {};
  const regionCountries = config.regionCountries || {};

  if (!Object.keys(regionChoices).length || !Object.keys(regionCountries).length) {
    return;
  }

  const countrySelectors = [
    'select[name="country"]',
    'select#country',
    'select[name="acf[field_69e0ae3cf1dce]"]',
    'select#acf-field_69e0ae3cf1dce'
  ].join(',');
  const regionSelectors = [
    'select[name="region"]',
    'select#region',
    'select[name="acf[field_69e0ae9bf1dcf]"]',
    'select#acf-field_69e0ae9bf1dcf'
  ].join(',');

  function normalizeCountry(value) {
    const compact = String(value || '').toLowerCase().replace(/[\s_-]/g, '');

    if (['ba', 'bih', 'bosnaihercegovina', 'bosniaandherzegovina'].includes(compact)) {
      return 'bosnaihercegovina';
    }

    if (['hr', 'hrv', 'hrvatska', 'croatia'].includes(compact)) {
      return 'hrvatska';
    }

    return compact;
  }

  function findRegionSelect(countrySelect) {
    const form = countrySelect.closest('form');

    if (form) {
      const regionSelect = form.querySelector(regionSelectors);

      if (regionSelect) {
        return regionSelect;
      }
    }

    return document.querySelector(regionSelectors);
  }

  function getPlaceholderOption(regionSelect) {
    if (!regionSelect.zdCrmPlaceholderOption) {
      const currentPlaceholder = Array.from(regionSelect.options).find(function (option) {
        return !option.value;
      });

      regionSelect.zdCrmPlaceholderOption = currentPlaceholder
        ? currentPlaceholder.cloneNode(true)
        : new Option(regionSelect.getAttribute('aria-label') || 'Regija', '');
    }

    return regionSelect.zdCrmPlaceholderOption.cloneNode(true);
  }

  function hasOption(regionSelect, value) {
    return Array.from(regionSelect.options).some(function (option) {
      return option.value === value;
    });
  }

  function regionIsApplicable(selectedCountry) {
    return selectedCountry === 'hrvatska' || selectedCountry === 'bosnaihercegovina';
  }

  function toggleRegionVisibility(regionSelect, isApplicable) {
    const wrapper = regionSelect.closest('.form-fields__field') || regionSelect.parentElement;

    if (wrapper) {
      wrapper.style.display = isApplicable ? '' : 'none';
    }

    regionSelect.required = isApplicable;
  }

  function filterRegionSelect(countrySelect, regionSelect, notify) {
    const selectedCountry = normalizeCountry(countrySelect.value);
    const isApplicable = regionIsApplicable(selectedCountry);
    const currentRegion = regionSelect.value;

    regionSelect.innerHTML = '';
    regionSelect.appendChild(getPlaceholderOption(regionSelect));

    Object.keys(regionChoices).forEach(function (value) {
      const optionCountry = normalizeCountry(regionCountries[value]);

      if (isApplicable && optionCountry === selectedCountry) {
        regionSelect.appendChild(new Option(regionChoices[value], value));
      }
    });

    regionSelect.disabled = !isApplicable;
    regionSelect.value = currentRegion && hasOption(regionSelect, currentRegion) ? currentRegion : '';

    toggleRegionVisibility(regionSelect, isApplicable);

    if (notify) {
      regionSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  document.querySelectorAll(countrySelectors).forEach(function (countrySelect) {
    const regionSelect = findRegionSelect(countrySelect);

    if (!regionSelect) {
      return;
    }

    filterRegionSelect(countrySelect, regionSelect, false);

    countrySelect.addEventListener('change', function () {
      filterRegionSelect(countrySelect, regionSelect, true);
    });
  });
});

jQuery(document).ready(function ($) {

    const $slider = $('.testimonials__wrapper__container__slider');
    const $nav    = $('.testimonials__wrapper__container__nav');

    if ($slider.length) {
        $slider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            appendDots: $nav,
            autoplay: true,
            autoplaySpeed: 5000,
            infinite: true,
            adaptiveHeight: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }

    $(document).ready(function () {
    const $checkbox = $('#companyinvoice');
    const $companyFields = $('.company-fields');
    const $companyInputs = $companyFields.find('input');

    function toggleCompanyFields() {
      const isChecked = $checkbox.is(':checked');

      $companyFields.css('display', isChecked ? 'flex' : 'none');

      $companyInputs.each(function () {
        $(this).prop('required', isChecked);

        if (!isChecked) {
          $(this).val('');
        }
      });
    }

    $checkbox.on('change', toggleCompanyFields);
    toggleCompanyFields();

    $('.myprofile__wrapper__content__wrapper__payment-details__payment-type__option__radio').on('change', function () {
      const $selectedOption = $(this).closest(
        '.myprofile__wrapper__content__wrapper__payment-details__payment-type__option'
      );

      $('.myprofile__wrapper__content__wrapper__payment-details__payment-type__option')
        .removeClass('is-checked');

      $selectedOption.addClass('is-checked');
    });
  });
});

jQuery(document).ready(function ($) {
    const $countryField = $('[name="country"]');
    const $priceEl = $('.js-package-price');
    const $currencyEl = $('.js-package-currency');
    const $pdvEl = $('.js-pdv-text');

    if (!$countryField.length || !$priceEl.length || !$currencyEl.length || !$pdvEl.length) {
        return;
    }

    function updatePriceByCountry() {
        const country = String($countryField.val() || '').toLowerCase().replace(/[\s_-]/g, '');
        const isBiH = ['ba', 'bih', 'bosnaihercegovina', 'bosniaandherzegovina'].includes(country);

        if (isBiH) {
            $priceEl.text($priceEl.data('price-km'));
            $currencyEl.text('KM');
            $pdvEl.text('Oslobođeni ste plaćanja PDV-a');
        } else {
            $priceEl.text($priceEl.data('price-eu'));
            $currencyEl.text('€');
            $pdvEl.text('PDV uključen');
        }
    }

    $countryField.on('change', updatePriceByCountry);

    updatePriceByCountry();
});

jQuery(function ($) {
    const $paymentDetails = $('.myprofile__wrapper__content__wrapper__payment-details');

    if ($paymentDetails.length) {
        $paymentDetails.addClass('is-loaded');
    }
});

jQuery(function ($) {
    const $paymentType = $('[name="payment_type"]');
    const $submitButton = $('.js-payment-submit');

    if (!$paymentType.length || !$submitButton.length) {
        return;
    }

    function updatePaymentButtonText() {
        const selectedPaymentType = $('[name="payment_type"]:checked').val();

        if (selectedPaymentType === 'transaction') {
            $submitButton.text('Zatraži ponudu');
        } else {
            $submitButton.text('Idi na plaćanje');
        }
    }

    $paymentType.on('change', updatePaymentButtonText);

    updatePaymentButtonText();
});

jQuery(document).ready(function ($) {
    const $anchorNav = $('.anchor-navigation__wrapper__nav');

    if (!$anchorNav.length) {
        return;
    }

    const $sections = $('section[id]')
        .not('.anchor-navigation')
        .filter(function () {
            return (
                $(this).attr('data-anchor-label') ||
                $(this).attr('aria-label')
            );
        });

    if (!$sections.length) {
        return;
    }

    function getHeaderOffset() {
        const $header = $('header');

        if (!$header.length) {
            return 0;
        }

        return $header.outerHeight() || 0;
    }

    function clearCurrentAnchor() {
        $anchorNav.find('a').removeClass('current-anchor-item');
    }

    function setCurrentAnchor(sectionId) {
        $anchorNav.find('a').each(function () {
            const $link = $(this);

            $link.toggleClass(
                'current-anchor-item',
                $link.data('target') === sectionId
            );
        });
    }

    // Prevent duplicate links if script runs more than once
    $anchorNav.empty();

    // Build anchor links only from labelled sections
    $sections.each(function () {
        const $section = $(this);
        const sectionId = $section.attr('id');

        if (!sectionId) {
            return;
        }

        const label =
            $section.attr('data-anchor-label') ||
            $section.attr('aria-label');

        if (!label) {
            return;
        }

        const $link = $('<a></a>', {
            href: '#' + sectionId,
            text: label,
            'aria-label': label,
            'data-target': sectionId
        });

        $anchorNav.append($link);
    });

    const visibleSections = new Map();

    function updateCurrentFromVisibleSections() {
        if (!visibleSections.size) {
            clearCurrentAnchor();
            return;
        }

        let activeSectionId = null;
        let closestTop = Infinity;

        visibleSections.forEach(function (entry, sectionId) {
            const distanceFromTop = Math.abs(entry.boundingClientRect.top);

            if (distanceFromTop < closestTop) {
                closestTop = distanceFromTop;
                activeSectionId = sectionId;
            }
        });

        if (activeSectionId) {
            setCurrentAnchor(activeSectionId);
        } else {
            clearCurrentAnchor();
        }
    }

    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
            function (entries) {
                entries.forEach(function (entry) {
                    const sectionId = entry.target.id;

                    if (entry.isIntersecting) {
                        visibleSections.set(sectionId, entry);
                    } else {
                        visibleSections.delete(sectionId);
                    }
                });

                updateCurrentFromVisibleSections();
            },
            {
                root: null,
                threshold: 0,
                rootMargin: '-' + getHeaderOffset() + 'px 0px -60% 0px'
            }
        );

        $sections.each(function () {
            observer.observe(this);
        });
    }

    $anchorNav.on('click', 'a', function (e) {
        e.preventDefault();

        const $clickedLink = $(this);
        const sectionId = $clickedLink.data('target');
        const target = document.getElementById(sectionId);

        if (!target) {
            return;
        }

        setCurrentAnchor(sectionId);

        const offset = getHeaderOffset() + 20;
        const targetTop =
            target.getBoundingClientRect().top + window.pageYOffset - offset;

        // Mobile-safe scroll. No smooth behavior to avoid scroll locking on mobile.
        window.scrollTo(0, targetTop);

        $clickedLink.blur();
    });

    clearCurrentAnchor();
});

    jQuery(document).ready(function ($) {
        const $fileInput = $('#profile_image');
        const $imagePreview = $('#profileImagePreview');

        $fileInput.on('change', function () {
            const file = this.files[0];

            if (!file) {
                return;
            }

            const allowedTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];

            if (!allowedTypes.includes(file.type)) {
                alert('Dozvoljeni su samo JPG, PNG, WEBP ili GIF formati.');
                $fileInput.val('');
                return;
            }

            const reader = new FileReader();

            reader.onload = function (event) {
                $imagePreview.attr('src', event.target.result);
            };

            reader.readAsDataURL(file);
        });
    });



jQuery(function ($) {
  if (typeof $.fn.fancybox !== 'function') {
    return;
  }

  $('[data-fancybox]').fancybox({
    animationEffect: false,
    image: {
      preload: true
    }
  });
});



jQuery(document).ready(function ($) {
  const $eventNav = $('.event-body__wrapper__content__nav');

  if (!$eventNav.length) {
    return;
  }

  function getHeaderOffset() {
    const $header = $('header');

    if (!$header.length) {
      return 0;
    }

    return $header.outerHeight() || 0;
  }

  function clearCurrentItem() {
    $eventNav
      .find('.event-body__wrapper__content__nav__item')
      .removeClass('is-current-item');
  }

  function setCurrentItem(sectionId) {
    $eventNav.find('.event-body__wrapper__content__nav__item').each(function () {
      const $link = $(this);
      const href = $link.attr('href');

      $link.toggleClass(
        'is-current-item',
        href === '#' + sectionId
      );
    });
  }

  const $navItems = $eventNav.find('.event-body__wrapper__content__nav__item');

  const $sections = $navItems
    .map(function () {
      const href = $(this).attr('href');

      if (!href || href.charAt(0) !== '#') {
        return null;
      }

      const section = document.getElementById(href.substring(1));

      if (!section) {
        $(this).hide();
        return null;
      }

      return section;
    });

  if (!$sections.length) {
    clearCurrentItem();
    return;
  }

  const visibleSections = new Map();

  function updateCurrentFromVisibleSections() {
    if (!visibleSections.size) {
      clearCurrentItem();
      return;
    }

    let activeSectionId = null;
    let closestTop = Infinity;

    visibleSections.forEach(function (entry, sectionId) {
      const distanceFromTop = Math.abs(entry.boundingClientRect.top);

      if (distanceFromTop < closestTop) {
        closestTop = distanceFromTop;
        activeSectionId = sectionId;
      }
    });

    if (activeSectionId) {
      setCurrentItem(activeSectionId);
    } else {
      clearCurrentItem();
    }
  }

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          const sectionId = entry.target.id;

          if (entry.isIntersecting) {
            visibleSections.set(sectionId, entry);
          } else {
            visibleSections.delete(sectionId);
          }
        });

        updateCurrentFromVisibleSections();
      },
      {
        root: null,
        threshold: 0,
        rootMargin: '-' + getHeaderOffset() + 'px 0px -60% 0px'
      }
    );

    $sections.each(function () {
      observer.observe(this);
    });
  }

  $eventNav.on('click', '.event-body__wrapper__content__nav__item', function (e) {
    e.preventDefault();

    const $clickedLink = $(this);
    const href = $clickedLink.attr('href');

    if (!href || href.charAt(0) !== '#') {
      return;
    }

    const target = document.getElementById(href.substring(1));

    if (!target) {
      return;
    }

    setCurrentItem(target.id);

    const offset = getHeaderOffset() + 20;
    const targetTop =
      target.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo(0, targetTop);

    $clickedLink.blur();
  });

  clearCurrentItem();
});

jQuery(function ($) {
  $('#copy-post-link').on('click', function (e) {
    e.preventDefault();

    const url = $(this).data('copy-url') || window.location.href;

    function showCopiedAlert() {
      alert('Kopirano');
    }

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(url).then(function () {
        showCopiedAlert();
      });

      return;
    }

    const $tempInput = $('<input>');
    $('body').append($tempInput);
    $tempInput.val(url).select();

    document.execCommand('copy');

    $tempInput.remove();

    showCopiedAlert();
  });
});


jQuery(document).ready(function ($) {
    // Share dropdown toggle
    $(document).on('click', '.js-share-toggle', function (e) {
        e.stopPropagation();
        var $wrapper = $(this).closest('.js-share-wrapper');
        var isOpen = $wrapper.hasClass('is-open');
        $('.js-share-wrapper').removeClass('is-open');
        $(this).attr('aria-expanded', 'false');
        if (!isOpen) {
            $wrapper.addClass('is-open');
            $(this).attr('aria-expanded', 'true');
        }
    });

    $(document).on('click', function (e) {
        if (!$(e.target).closest('.js-share-wrapper').length) {
            $('.js-share-wrapper').removeClass('is-open');
            $('.js-share-toggle').attr('aria-expanded', 'false');
        }
    });

    $(document).on('click', '.js-share-copy', function (e) {
        e.preventDefault();
        var url = $(this).data('url') || window.location.href;
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(url).then(function () { alert('Kopirano'); });
        } else {
            var $tmp = $('<input>');
            $('body').append($tmp);
            $tmp.val(url).select();
            document.execCommand('copy');
            $tmp.remove();
            alert('Kopirano');
        }
    });
});

jQuery(document).ready(function ($) {
    // Search load more (posts & pages)
    $(document).on('click', '.js-load-more-search', function (e) {
        e.preventDefault();

        var $btn    = $(this);
        if ($btn.hasClass('disabled')) return;
        var $grid   = $('#' + $btn.data('grid'));
        var label   = $btn.data('label-more') || 'Učitajte više';

        $btn.addClass('disabled').text('Učitavam...');

        $.ajax({
            url: zd_ajax.ajax_url,
            type: 'POST',
            dataType: 'json',
            data: {
                action:    'zd_load_more_search',
                nonce:     $btn.data('nonce'),
                search:    $btn.data('search'),
                post_type: $btn.data('post-type'),
                offset:    $btn.data('offset'),
                base_url:  $btn.data('base-url'),
                param:     $btn.data('param')
            },
            success: function (response) {
                if (response.success && response.data.html) {
                    $grid.append(response.data.html);
                    $btn.data('offset', response.data.offset);
                    if (response.data.url) {
                        history.pushState(null, '', response.data.url);
                    }
                    if (response.data.has_more) {
                        $btn.attr('href', response.data.next_url).removeClass('disabled').text(label);
                    } else {
                        $btn.closest('.categories-others__wrapper__others__load-more').remove();
                    }
                } else {
                    $btn.closest('.categories-others__wrapper__others__load-more').remove();
                }
            },
            error: function () {
                $btn.removeClass('disabled').text(label);
            }
        });
    });

    // Author posts load more
    $(document).on('click', '.js-load-more-author', function (e) {
        e.preventDefault();

        var $btn  = $(this);
        if ($btn.hasClass('disabled')) return;
        var $grid = $('#author-posts-grid');

        $btn.addClass('disabled').text('Učitavam...');

        $.ajax({
            url: zd_ajax.ajax_url,
            type: 'POST',
            dataType: 'json',
            data: {
                action:    'zd_load_more_author_posts',
                nonce:     $btn.data('nonce'),
                author_id: $btn.data('author-id'),
                offset:    $btn.data('offset')
            },
            success: function (response) {
                if (response.success && response.data.html) {
                    $grid.append(response.data.html);
                    $btn.data('offset', response.data.offset);
                    if (response.data.url) {
                        history.pushState(null, '', response.data.url);
                    }
                    if (response.data.has_more) {
                        $btn.attr('href', response.data.next_url).removeClass('disabled').text('Učitajte više članaka');
                    } else {
                        $btn.closest('.categories-others__wrapper__others__load-more').remove();
                    }
                } else {
                    $btn.closest('.categories-others__wrapper__others__load-more').remove();
                }
            },
            error: function () {
                $btn.removeClass('disabled').text('Učitajte više članaka');
            }
        });
    });

    // Podcast load more
    $(document).on('click', '.js-load-more-podcasts', function (e) {
        e.preventDefault();

        var $btn  = $(this);
        if ($btn.hasClass('disabled')) return;
        var $grid = $('#podcasts-grid');

        $btn.addClass('disabled').text('Učitavam...');

        $.ajax({
            url: zd_ajax.ajax_url,
            type: 'POST',
            dataType: 'json',
            data: {
                action:   'zd_load_more_podcasts',
                nonce:    $btn.data('nonce'),
                offset:   $btn.data('offset'),
                base_url: $btn.data('base-url'),
                param:    $btn.data('param')
            },
            success: function (response) {
                if (response.success && response.data.html) {
                    $grid.append(response.data.html);
                    $btn.data('offset', response.data.offset);
                    if (response.data.url) {
                        history.pushState(null, '', response.data.url);
                    }
                    if (response.data.has_more) {
                        $btn.attr('href', response.data.next_url).removeClass('disabled').text('Učitajte više');
                    } else {
                        $btn.closest('.podcasts__wrapper__load-more').remove();
                    }
                } else {
                    $btn.closest('.podcasts__wrapper__load-more').remove();
                }
            },
            error: function () {
                $btn.removeClass('disabled').text('Učitajte više');
            }
        });
    });
});

jQuery(document).ready(function ($) {
    $(document).on('click', '.js-load-more-category-posts', function (e) {
        e.preventDefault();

        const $button = $(this);
        if ($button.hasClass('disabled')) return;
        const $grid = $('#categories-others-grid');

        $button.addClass('disabled').text('Učitavam...');

        $.ajax({
            url: zd_ajax.ajax_url,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'load_more_category_posts',
                nonce: $button.data('nonce'),
                cat_id: $button.data('cat-id'),
                excluded: $button.attr('data-excluded'),
                is_subcategory: $button.data('is-subcategory'),
                paged: $button.data('paged')
            },
            success: function (response) {
                if (response.success && response.data.html) {
                    $grid.append(response.data.html);

                    $button.attr('data-excluded', JSON.stringify(response.data.excluded));
                    $button.data('paged', response.data.paged);

                    if (response.data.url) {
                        history.pushState(null, '', response.data.url);
                    }

                    if (response.data.has_more) {
                        $button.attr('href', response.data.next_url).removeClass('disabled').text('Učitaj još članaka');
                    } else {
                        $button.remove();
                    }
                } else {
                    $button.remove();
                }
            },
            error: function () {
                $button.removeClass('disabled').text('Učitaj još članaka');
            }
        });
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const ads = document.querySelectorAll('.custom-ad');

    if (!ads.length) {
        return;
    }

    const trackedImpressions = new Set();

    const observer = new IntersectionObserver(
        function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting || entry.intersectionRatio < 0.5) {
                    return;
                }

                const ad = entry.target;
                const adId = ad.dataset.adId;

                if (!adId || trackedImpressions.has(adId)) {
                    return;
                }

                trackedImpressions.add(adId);

                if (typeof window.gtag === 'function') {
                    window.gtag('event', 'ad_impression', {
                        ad_id: adId,
                        ad_name: ad.dataset.adName || ''
                    });
                }

                observer.unobserve(ad);
            });
        },
        {
            threshold: 0.5
        }
    );

    ads.forEach(function (ad) {
        observer.observe(ad);

        ad.addEventListener('click', function () {
            if (typeof window.gtag === 'function') {
                window.gtag('event', 'ad_click', {
                    ad_id: ad.dataset.adId || '',
                    ad_name: ad.dataset.adName || '',
                    destination_url: ad.href
                });
            }
        });
    });
});